<template>
    <RouterLink :to="'esquema/' + entidad.id">
        <!-- From Uiverse.io by Cobp -->
        <section class="file-section">
            <div class="file">
                <div class="work-5" :style="{ '--color': entidad.color }"></div>
                <div class="work-4"></div>
                <div class="work-3"></div>
                <div class="work-2"></div>
                <div class="work-1 d-flex justify-content-center align-items-center">
                    <div class="icon icon-shape icon-lg text-center"
                        style="display: grid;justify-content: center;align-items: center;">
                        <i :class="entidad.icono" style="font-size: xxx-large; color: #f96b2f;"></i>
                    </div>
                    
                </div>
            </div>
            <p class="hover-text">{{ entidad.nombre }}</p>
        </section>
    </RouterLink>

</template>

<script>
export default {
    name: "FolderCard2",
    props: {
        entidad: Object,
    }
}
</script>

<style scoped>
.file-section {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}

.file {
    position: relative;
    width: 15rem;
    /* w-60 */
    height: 10rem;
    /* h-40 */
    cursor: pointer;
    transform-origin: bottom;
    perspective: 1500px;
    z-index: 50;
}

/* --- work-5 --- */
.work-5 {
    background-color: #d97706;
    /* bg-amber-600 */
    width: 100%;
    height: 100%;
    transform-origin: top;
    border-radius: 1rem;
    /* rounded-2xl */
    border-top-left-radius: 0;
    position: relative;
    transition: all 0.3s ease;
}

.file:hover .work-5 {
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.work-5::after {
    content: "";
    position: absolute;
    bottom: 99%;
    left: 0;
    width: 5rem;
    /* 20px * 0.25rem = 80px */
    height: 1rem;
    /* 16px */
    background-color: var(--color);
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
}

.work-5::before {
    content: "";
    position: absolute;
    top: -15px;
    left: 75.5px;
    width: 1rem;
    /* 4px * 0.25rem */
    height: 1rem;
    background-color: var(--color);
    clip-path: polygon(0 35%, 0% 100%, 50% 100%);
}

/* --- work-4 --- */
.work-4 {
    position: absolute;
    top: 0.25rem;
    bottom: 0.25rem;
    left: 0.25rem;
    right: 0.25rem;
    background-color: #a1a1aa;
    /* zinc-400 */
    border-radius: 1rem;
    transition: all 0.3s ease;
    transform-origin: bottom;
    user-select: none;
}

.file:hover .work-4 {
    transform: rotateX(-20deg);
}

/* --- work-3 --- */
.work-3 {
    position: absolute;
    top: 0.25rem;
    bottom: 0.25rem;
    left: 0.25rem;
    right: 0.25rem;
    background-color: #d4d4d8;
    /* zinc-300 */
    border-radius: 1rem;
    transition: all 0.3s ease;
    transform-origin: bottom;
}

.file:hover .work-3 {
    transform: rotateX(-30deg);
}

/* --- work-2 --- */
.work-2 {
    position: absolute;
    top: 0.25rem;
    bottom: 0.25rem;
    left: 0.25rem;
    right: 0.25rem;
    background-color: #e5e5e5;
    /* zinc-200 */
    border-radius: 1rem;
    transition: all 0.3s ease;
    transform-origin: bottom;
}

.file:hover .work-2 {
    transform: rotateX(-38deg);
}

/* --- work-1 --- */
.work-1 {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 156px;
    background: linear-gradient(to top, #f59e0b, #fbbf24);
    /* amber-500 → amber-400 */
    border-radius: 1rem;
    border-top-right-radius: 0;
    transition: all 0.3s ease;
    transform-origin: bottom;
    display: flex;
    align-items: flex-end;
}

.work-1::after {
    content: "";
    position: absolute;
    bottom: 99%;
    right: 0;
    width: 146px;
    height: 16px;
    background-color: #fbbf24;
    /* amber-400 */
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
}

.work-1::before {
    content: "";
    position: absolute;
    top: -10px;
    right: 142px;
    width: 12px;
    height: 12px;
    background-color: #fbbf24;
    clip-path: polygon(100% 14%, 50% 100%, 100% 100%);
}

.file:hover .work-1 {
    box-shadow: inset 0 20px 40px #fbbf24, inset 0 -20px 40px #d97706;
    transform: rotateX(-46deg) translateY(1px);
}

/* --- texto --- */
.hover-text {
    font-size: 1.875rem;
    /* text-3xl */
    padding-top: 1rem;
    color: #0d1e3f;
}
</style>